<template>
  <span
    role="img"
    :aria-label="$t('CHAT_LIST.LINE_MENTION.LABEL')"
    :title="$t('CHAT_LIST.LINE_MENTION.LABEL')"
    class="bg-n-brand rounded-full size-4 font-semibold text-xxs leading-3 text-white inline-grid place-items-center flex-shrink-0"
  >
    {{ $t('CHAT_LIST.LINE_MENTION.SYMBOL') }}
  </span>
</template>
